import debug from 'debug';

const log = debug('fus078/components');

const files = require.context(__dirname, true, /index\.js$/);
files.keys().forEach(files);




// WEBPACK FOOTER //
// ./client/src/site__fus078/components/index.js